import LocalStorage from 'app-lib/LocalStorage'
import AirdropService from 'bzx-common/src/services/AirdropService'
import DaoService from 'bzx-common/src/services/DaoService'
import LendService from 'bzx-common/src/services/LendService'
import LoanService from 'bzx-common/src/services/LoanService'
import MigrateService from 'bzx-common/src/services/MigrateService'
import sentryService from 'bzx-common/src/services/sentryService'
import { createBrowserHistory, History } from 'history'
import debugService from './debugService'
import fulcrumProvider, { FulcrumProvider } from './FulcrumProvider'

export interface IServices {
  airdropService: AirdropService
  daoService: DaoService
  fulcrumProvider: FulcrumProvider
  history: History
  lendService: LendService
  loanService: LoanService
  migrateService: MigrateService
  start: () => void
  storage: LocalStorage
}

const airdropService = new AirdropService(fulcrumProvider)
const daoService = new DaoService(fulcrumProvider)
const lendService = new LendService(fulcrumProvider)
const migrateService = new MigrateService(fulcrumProvider)
const history = createBrowserHistory()
const loanService = new LoanService(fulcrumProvider)
const storage = new LocalStorage('ooki')

/**
 * Start / Init services like Sentry
 */
function start() {
  if (process.env.NODE_ENV === 'production') {
    sentryService.init(fulcrumProvider)
  }
  debugService.start(history)
}

export default {
  airdropService,
  daoService,
  fulcrumProvider,
  history,
  lendService,
  loanService,
  migrateService,
  start,
  storage,
}
